var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { BrandRenderLayout } from "../../brand/steps/brand-render-layout";
import { BrandRenderTheme } from "../../brand/steps/brand-render-theme";
import { BundleKeyHelper } from "../../../../../services/modules/brand-client.service";
import { LotteryClientService } from "../../../../../services/modules/lottery-client.service";
var BundleRenderDialog = /** @class */ (function () {
    function BundleRenderDialog(dialogClientService, i18N, notificationService, lotteryClientService, layout, theme) {
        var _this = this;
        this.dialogClientService = dialogClientService;
        this.i18N = i18N;
        this.lotteryClientService = lotteryClientService;
        this.layout = layout;
        this.theme = theme;
        this.selectedSection = null;
        // Inline text-edit mode: threads to the shared preview so the bundle page's text can be clicked and
        // edited in place, then written to the theme's current-language tokens.
        this.editText = false;
        this.previewBrandId = null;
        this.previewTemplateName = null;
        this.previewThemeName = null;
        this.previewBundleId = null;
        this.previewBundleKey = null;
        // True while a right-panel click drives the left selection, so the round-trip doesn't reopen the group.
        this.syncingFromTheme = false;
        this.layout.embeddedPreview = false;
        this.theme.embeddedPreview = false;
        this.layout.onSelect = function (section) { return _this.onLayoutSelect(section); };
        this.theme.onSelectVariant = function (variantId) { return _this.onThemeSelectVariant(variantId); };
        // The Style panel reads placement live from the layout panel and refreshes its colour groups when
        // a section is added/removed there.
        this.theme.layoutSectionsProvider = function () { return _this.layout.layout ? _this.layout.layout.sections : null; };
        this.layout.onLayoutChanged = function () { return _this.theme.refreshColorSections(); };
    }
    BundleRenderDialog.prototype.activate = function (model) {
        var _this = this;
        this.item = model;
        var nav = model.navigationInfo || {};
        // Both child editors read item only in brand mode; a minimal adapter keeps any HTML bindings safe.
        this.adapterItem = { brandId: nav.brandId, activeBrandLotteries: nav.brandLotteries || [], brandLanguages: nav.brandLanguages || [] };
        // Scope both panes to this bundle. Set before the view composes the children (their onActivated
        // reads these), and supply brand/template directly since the model is a BundleModel.
        this.layout.bundleId = this.theme.bundleId = model.bundleId;
        this.layout.overrideBrandId = this.theme.overrideBrandId = nav.brandId;
        this.layout.overrideTemplateName = this.theme.overrideTemplateName = nav.brandTemplateInternalName;
        // Centre preview targets this bundle's ID-backed page.
        this.previewBrandId = nav.brandId;
        this.previewTemplateName = nav.brandTemplateInternalName;
        this.previewThemeName = nav.brandThemeInternalName;
        this.previewBundleId = model.bundleId;
        this.previewBundleKey = BundleKeyHelper.getKey(model.name);
        // "Copy from another bundle": the brand's other bundles (exclude this one). Loaded async.
        // keyPrefix/itemKeyPrefix re-prefix item-scoped text/image keys from the source bundle slug to this one.
        this.theme.itemKeyPrefix = BundleKeyHelper.getKey(model.name);
        if (nav.brandId)
            this.lotteryClientService.getBundlesByBrand(nav.brandId).then(function (bundles) {
                _this.theme.copyCandidates = (bundles || [])
                    .filter(function (b) { return b.bundleId && b.bundleId !== model.bundleId; })
                    .map(function (b) {
                    var name = b.name || ("#" + b.bundleId);
                    return { key: "b" + b.bundleId, label: name, keyPrefix: BundleKeyHelper.getKey(name), bundleId: b.bundleId };
                });
            }).catch(function () { });
    };
    BundleRenderDialog.prototype.attached = function () {
        // Both embedded editors share this one preview for highlight + reload-on-save.
        this.layout.preview = this.preview;
        this.theme.preview = this.preview;
    };
    BundleRenderDialog.prototype.onLayoutSelect = function (section) {
        this.selectedSection = section;
        if (this.theme && section && !this.syncingFromTheme)
            this.theme.openColorSection(section);
    };
    BundleRenderDialog.prototype.onThemeSelectVariant = function (variantId) {
        this.syncingFromTheme = true;
        this.layout.selectByVariant(variantId);
        this.syncingFromTheme = false;
    };
    Object.defineProperty(BundleRenderDialog.prototype, "selectedSectionLabel", {
        get: function () {
            return this.selectedSection ? this.layout.variantLabel(this.selectedSection) : null;
        },
        enumerable: false,
        configurable: true
    });
    // An inline edit was committed in the preview: write it to the theme's current-language text tokens.
    BundleRenderDialog.prototype.onTextEdit = function (key, value) {
        if (this.theme)
            this.theme.applyInlineText(key, value);
    };
    BundleRenderDialog.prototype.close = function () {
        this.dialogClientService.hide();
    };
    BundleRenderDialog = __decorate([
        autoinject,
        __metadata("design:paramtypes", [DialogClientService,
            I18N,
            NotificationClientService,
            LotteryClientService,
            BrandRenderLayout,
            BrandRenderTheme])
    ], BundleRenderDialog);
    return BundleRenderDialog;
}());
export { BundleRenderDialog };
